import React, { Fragment } from "react";
import PropTypes from "prop-types";
import FormErrorMessage from "./FormErrorMessage";
import FormSuccessMessage from "./FormSuccessMessage";

const FormInfo = (props) => (
  <Fragment>
    {props.successMessage && (
      <FormSuccessMessage successMessage={props.successMessage} />
    )}
    {!props.successMessage && props.errorMessage && (
      <FormErrorMessage errorMessage={props.errorMessage} />
    )}
  </Fragment>
);

FormInfo.propTypes = {
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
};

export default FormInfo;



// WEBPACK FOOTER //
// ./src/components/forms/FormInfo.js